module.exports = __webpack_public_path__ + "static/open-sans-v27-latin-regular-07f8c319707ddebe0ee6cfe483d52d5b.woff";